import { render, staticRenderFns } from "./SessionVideoModal.vue?vue&type=template&id=70ac058e"
import script from "./SessionVideoModal.vue?vue&type=script&lang=ts"
export * from "./SessionVideoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports